@if (data) {
  <mb-card-base class="column-card content-top">
    @if (data.image) {
      <figure media>
        <mb-image [media]="data.image"></mb-image>
      </figure>
    }
    <h4 class="test-car-title" headline>{{ data.title }}</h4>
    <div class="test-car-specs" text>
      @for (item of data.cardSpecs; track item.label) {
        <div class="key-item-pair copy-m">
          <span
            ><strong>{{ item.label }}</strong></span
          >
          <span>{{ item.value }}</span>
        </div>
      }
    </div>
    @if (data.fuelLabel) {
      <span class="fuel-label copy-s" [innerHTML]="data.fuelLabel" fuel-label></span>
    }
    @if (data.document) {
      <mb-action-container
        [resource]="data.document"
        [buttonItems]="actions"
        (actionClick)="actionClick.emit($event)"
        action-container
      >
      </mb-action-container>
    }
  </mb-card-base>
}
